module.exports = window.__clic_libs["datatables.net"];